import { SPACE, BACKSPACE, TRASH } from '../../../logic/search/search.constants';

export * from './customer/default/keyboard.constants';

export { SPACE, BACKSPACE, TRASH };

export const LETTER_SELECTED_SIGNAL = 'letterSelected';

export const LETTER_REMOVED_SIGNAL = 'letterRemoved';

export const ITEMS_PER_ROW = 6;

export const BUTTON_LENGTH = 2;

export const SPECIAL_KEYS = {
  [SPACE]: {
    icon: { name: 'Space', type: 'icon' },
    keyLength: BUTTON_LENGTH,
  },
  [BACKSPACE]: {
    icon: { name: 'BackSpace', type: 'icon' },
    keyLength: BUTTON_LENGTH,
  },
  [TRASH]: {
    icon: { name: 'Trash', type: 'icon' },
    keyLength: BUTTON_LENGTH,
  },
};
